// components/Accordion.tsx

import React from 'react';
import { Accordion as MUIAccordion, AccordionSummary, Button, Typography, Box, Chip } from '@mui/material';
import styled from 'styled-components';
import AccordionDetails from './AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
const StyledAccordion = styled(MUIAccordion)`
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-bottom: 16px;
  cursor:pointer;
`;

const StyledAccordionSummary = styled(AccordionSummary)`
  background: #f5f5f5;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 16px;
  cursor:pointer;

  .summary-content {
    display: flex;
    justify-content: center;
    width: 100%;
    cursor:pointer;
  }

  .header-values {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 48px;
    width: 100%;
    text-align: center;
  }

  .view-more-btn {
    display: flex;
    justify-content: end;
    margin-top: 8px;
    width: 10%;
  }
`;

const StyledAccordionDetails = styled.div`
  padding: 16px;
`;

interface AccordionProps {
  expanded: boolean;
  onChange: () => void;
  order:any;
}

const statuscolors:any = {
  order_placed: "info",
  order_cancelled: 'error',
  order_fulfilled: 'success',
  paid:"success",
  unpaid:"error",
  refunded:"info"
};
const formattedStatus = (status: string = 'unknown') => {
  const formatted = status.replace('order_', '');
  return formatted.charAt(0).toUpperCase() + formatted.slice(1);
};

const Accordion: React.FC<AccordionProps> = ({ expanded, onChange ,order}) => {
  return (
    <StyledAccordion expanded={expanded} onChange={onChange}>
      <StyledAccordionSummary  expandIcon={<ExpandMoreIcon />}>
        <div className="summary-content">
          <div className="header-values">
            <Box>
              <Typography variant="body2" fontWeight="bold"> Order ID</Typography>
              <Typography variant="body1">{order?.order_id}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="bold">Total Items</Typography>
              <Typography variant="body1">{order?.total_no_of_items}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="bold">Total Price</Typography>
              <Typography variant="body1">₹{order?.total_price?.toFixed(2)}</Typography>
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="bold">Order Status</Typography>
              <Chip size="small" color={statuscolors[order?.order_status]||"primary"} label={formattedStatus(order?.order_status)} variant='outlined'/>
              {/* <Typography variant="body1"></Typography> */}
            </Box>
            <Box>
              <Typography variant="body2" fontWeight="bold">Payment Status</Typography>
              <Chip size="small" color={statuscolors[order?.payment_status]||"primary"} label={formattedStatus(order?.payment_status||"unknown")} variant='outlined'/>
              {/* <Typography variant="body1"></Typography> */}
            </Box>
          </div>
        </div>
        <div className="view-more-btn">
          {/* <Button variant="outlined" size="small" color="primary">
          <ExpandMoreIcon />
          </Button> */}
        </div>
      </StyledAccordionSummary>
      <StyledAccordionDetails>
      <AccordionDetails order={order}  />
      </StyledAccordionDetails>
    </StyledAccordion>
  );
};

export default Accordion;
